import { useState } from 'react'
import { ContainerDragAndDropImage } from './styles'

export function InputDragAndDrop({ setImages, images }) {
  const [dragging, setDragging] = useState(false)

  const handleDragEnter = (e) => {
    e.preventDefault()
    setDragging(true)
  }

  const handleDragLeave = (e) => {
    e.preventDefault()
    setDragging(false)
  }

  const handleDrop = (e) => {
    e.preventDefault()
    setDragging(true)

    // Obter os arquivos soltos
    const files = Array.from(e.dataTransfer.files)

    setImages(files)
  }

  const handleImages = (e) => {
    const files = Array.from(e.target.files)

    setImages(files)
  }

  return (
    <ContainerDragAndDropImage
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
      dragging={dragging}
      htmlFor="files"
    >
      <input
        id="files"
        name="files"
        type="file"
        multiple
        onChange={handleImages}
        style={{
          display: 'none',
        }}
      />

      {images.length === 0
        ? 'Arraste e solte as imagens aqui'
        : `Você soltou ${images.length} imagens`}
    </ContainerDragAndDropImage>
  )
}
